
import { Options, Vue } from 'vue-class-component';
import { CourseProduct, Product } from "@/data/products";
import { loadScript } from "@paypal/paypal-js";
import {
    OnApproveActions,
    OnApproveData,
    OnCancelledActions,
    PayPalButtonsComponent
} from "@paypal/paypal-js/types/components/buttons";
import OrderService from "@/services/OrderService";
import Alert from "@/components/Alert.vue";

@Options({
    props: {
        paypalClientId: {
            type: String,
            required: true,
        },
        product: {
            type: Object,
            required: true,
        },
        /*region: {
            type: Boolean,
            required: true,
        }*/
        gatewayId: {
            type: Number,
            required: true,
        },
        additionalOrderData: { // additional-order-data
            type: Object,
            required: false,
            default: {},
        },
    },
    components: {
        Alert,
    },
    emits: {
        success: (value: any) => value === null || typeof value === 'string' || Array.isArray(value),
    },
})
export default class PayPalExpressPayment extends Vue {
    paypalClientId!: string
    product!: Product|CourseProduct
    additionalOrderData!: Record<string, any>

    // loading = false

    gatewayId!: number

    paypalLoading = false
    paypalSuccess: boolean|null = null
    paypalError: string|null = null

    paypalButtons: PayPalButtonsComponent|null = null

    /*getRegisterUrl(courseId: number) {
        return this.regionLocal ? NavigationService.buildRouteUrl('register', { region: this.regionLocal.id, course: courseId }) : '#';
    }*/

    loadPayPal() {
        const product = this.product;

        this.paypalLoading = true;
        loadScript({
            'client-id': this.paypalClientId, // @TODO: PayPal client (?) id
            currency: 'EUR',
        }).then((paypal: any) => {
            this.paypalError = null;

            this.paypalButtons = paypal.Buttons({
                style: {
                    layout: 'horizontal'
                },
                createOrder: (data: any, actions: any) => {
                    return OrderService.orderCreateByProduct(this.gatewayId, product, this.additionalOrderData)?.then(result => {
                        if( !result.data?.gatewayReference ) {
                            this.paypalError = 'Es ist ein Fehler beim Laden von PayPal aufgetreten. Bitte versuchen Sie es erneut.';
                            throw new Error('no gateway reference returned');
                        }
                        return result.data.gatewayReference as string;
                    }).catch(error => {
                        this.paypalError = error?.response?.data?.message || 'Es ist ein Fehler beim Laden des Produkts aufgetreten. Bitte versuchen Sie es erneut.';
                        console.error(error);
                        return '';
                    });
                },
                onApprove: (data: OnApproveData, actions: OnApproveActions) => {
                    return OrderService.paymentCapture(this.gatewayId, data.orderID).then(result => {
                        this.orderSucceeded();
                    }).catch(error => {
                        this.paypalError = error?.response?.data?.message || 'Es ist ein Fehler beim Durchführen der PayPal-Transaktion aufgetreten. Bitte versuchen Sie es erneut.';
                        console.error(error);
                    });
                },
                onCancel: (data: any, actions: OnCancelledActions) => {
                    console.warn('paypal checkout was aborted', arguments);
                    return OrderService.paymentCancel(this.gatewayId, data.orderID).then(result => {
                        //
                    }).catch(error => {
                        console.error(error);
                    });
                },
            });
            this.paypalButtons?.render(this.$refs.paypalButton as HTMLElement);
        }).catch(() => {
            this.paypalError = 'Es ist ein Fehler beim Laden von PayPal aufgetreten. Bitte versuchen Sie es erneut.';
        }).finally(() => this.paypalLoading = false);
    }

    cleanupPayPal() {
        if( this.paypalButtons && this.paypalButtons.close ) {
            this.paypalButtons.close();
            this.paypalSuccess = null;
            this.paypalError = null;
        }
    }

    orderSucceeded() {
        this.paypalSuccess = true;
        this.$emit('success'/*, 'Foobar Message'*/); // add message here
    }

    mounted() {
        this.loadPayPal();

        /*
        this.$watch('product', () => {
            this.cleanupPayPal();
            this.$nextTick(() => {
                this.loadPayPal();
            });
        }, { immediate: true });
        */
    }

    beforeUnmount() {
        this.cleanupPayPal();
    }
}
